import { useState, useEffect, useContext } from 'react'
import { PageContext, ThemeContext } from '../Context'
import Tutorial from './Tutorial'
import Account from './Account'
import Edition from './Edition'
import Insertions from './Insertions'
import CGUPage from './CGUPage'
//Partie Main.

function 
Main() {
   const {theme} = useContext(ThemeContext)
   const {page} = useContext(PageContext)

   if (page === 'Tutorial') {
      return (
         <div className={theme}>
            <Tutorial />
         </div>
      )
   } else if (page === 'Account') {
    return (
         <div className={theme}>
            <Account />
         </div>
      )
   } else if (page === 'Insertions') {
    return (
         <div className={theme}>
            <Insertions />
         </div>
      )
  } else if (page === 'CGU') {
    return (
      <div className={theme}>
        <CGUPage />
      </div>
    )
  } else {
      return (
         <div className={theme}>
            <Edition />
         </div>
      )
   }
}

export default Main